import {useCallback} from "react";
import {useFormContext} from "react-hook-form";

import {MultiServiceSelect} from "@/components/multiServiceSelect/MultiServiceSelect.tsx";
import {ServiceGroup, ServiceTag} from "@/lib/types/checks.ts";
import {DashboardFormFields} from "@/pages/dashboard/edit/dashboardForm.ts";

interface DashboardFormCheckPickerProps {
  tags: ServiceTag[];
  monitoringServiceTypes: ServiceGroup[];
}

export const DashboardFormCheckPicker = ({tags, monitoringServiceTypes}: DashboardFormCheckPickerProps) => {
  const {getValues, setValue} = useFormContext<DashboardFormFields>();

  const selectedCheckIds = getValues("services_selected").map((s) => s.id);

  const handleAppend = useCallback(
    (id: number) => {
      const current = getValues("services_selected");
      setValue("services_selected", [...current, {id}]);
    },
    [getValues, setValue]
  );

  const handleReplace = useCallback(
    (ids: number[]) => {
      setValue(
        "services_selected",
        ids.map((id) => ({id}))
      );
    },
    [setValue]
  );

  return (
    <MultiServiceSelect
      monitoringServiceTypes={monitoringServiceTypes}
      tags={tags}
      defaultValue={selectedCheckIds}
      onAppend={handleAppend}
      onReplace={handleReplace}
    />
  );
};
